import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useModal } from 'store/modal';
import CreateEntity from 'components/crud/CreateEntity';
import { ISelectOptionProps } from 'components/form/types';
import { useHistory } from 'react-router';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import TemplateForm from './TemplateForm';
import { IDropdowns, IInputs } from '../types';
import { formatDataOnSubmit } from '../dataFormatters';

interface IProps {
  templatesEntityName: string;
  templateDataOptions: IDropdowns;
  categories: ISelectOptionProps[];
}

const CreateForm: FC<IProps> = ({ templatesEntityName, templateDataOptions, categories }: IProps) => {
  const { showModal } = useModal();
  const { client } = useActiveClientContext();
  const methods = useForm<IInputs>({
    defaultValues: {
      is_active: true,
    },
  });
  const history = useHistory();

  return (
    <CreateEntity
      entity={templatesEntityName}
      methods={methods}
      onSuccess={(res: any) => {
        const { id, name, tokens } = res.data;
        const nextPage =
          tokens.length > 0
            ? buildClientUrl(`/document-templates/manage-tokens/${id}`, client)
            : buildClientUrl('/document-templates', client);
        history.push({
          pathname: nextPage,
          state: {
            isEdit: false,
            templateName: name,
          },
        });
        if (!tokens.length)
          showModal({
            type: 'success',
            content: (
              <>
                Създадохте шаблон за документ&nbsp;
                <span className="font-weight-bold">{name}</span>.
              </>
            ),
          });
      }}
      queryKey={buildClientEntity(templatesEntityName, client)}
    >
      {(create: any) => (
        <TemplateForm
          methods={methods}
          handleSubmit={data => create(formatDataOnSubmit(data))}
          btnLabel="Запази"
          templateDataOptions={templateDataOptions}
          categories={categories}
          canEdit
          isMultilingual={client?.is_multilingual}
        />
      )}
    </CreateEntity>
  );
};

export default CreateForm;
